import extended from '../util/extended';
import interval from '../util/interval';
/**
 * 计算线性的 ticks，使用 wilkinson extended 方法
 * @param cfg 度量的配置项
 * @returns 计算后的 ticks
 */
export default function linear(cfg) {
    var min = cfg.min, max = cfg.max, tickCount = cfg.tickCount, nice = cfg.nice, tickInterval = cfg.tickInterval;
    if (tickInterval) {
        return interval(min, max, tickInterval).ticks;
    }
    return extended(min, max, tickCount, nice).ticks;
}
//# sourceMappingURL=linear.js.map